import React, { useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchData } from '../reduxactions/mobileactions/MobDonationsAction';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const MobileDonationlist = () => {
    const [globalFilter, setGlobalFilter] = useState('');
    const { uid } = useParams();
    const { usertype } = useParams();

    console.log('Row ID:', uid);

    const mobdata = useSelector((state: RootState) => state.mobiledash.data);

    const dispatch = useDispatch()
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchData(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    // To get data
    useEffectOnce(() => {
      fetchDataAsync();
    }, [dispatch]);
  
  
    return (
      <div className="admin-layout-container">
        <div className="row">
    <div className="main-content">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="grid mb-2">
                <div className="col-6">
                  <h1>Latest Donations</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="content">               
           {usertype === 'organisation' && (
            <div className="grid">
              <div className="col-1"></div>
              <div className="col-10">
                <div className="card card-primary">
                  <Card title="">
                    <Panel header="">
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                        </span>
                      </div>
                      <DataTable value={mobdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="organisationfirstname" sortable header="Donor Name"></Column>
                        <Column field="CreateDate" sortable header="Date"></Column>
                        <Column field="Amount" sortable header="Amount"></Column>
                        <Column field="donationStatus" sortable header="Status"></Column>
                      </DataTable>
                    </Panel>
                  </Card>
                </div>
  
              </div>
              <div className="col-1"></div>
            </div>
           )}
          </section>

          <section className="content">
          {usertype === 'donor' && (

            <div className="grid">
              <div className="col-1"></div>
              <div className="col-10">
                <div className="card card-primary">
                  <Card title="">
                    <Panel header="">
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                        </span>
                      </div>
                      <DataTable value={mobdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="donorfirstname" sortable header="Organization Name"></Column>
                        <Column field="CreateDate" sortable header="Donate Date"></Column>
                        <Column field="Amount" sortable header="Donated Amount"></Column>
                        <Column field="donationStatus" sortable header="Status"></Column>
                      </DataTable>
                    </Panel>
                  </Card>
                </div>
  
              </div>
              <div className="col-1"></div>
            </div>
          )}
          </section>
          <section className="content">
          {usertype === 'fundmanager' && (
            <div className="grid">
              <div className="col-1"></div>
              <div className="col-10">
                <div className="card card-primary">
                  <Card title="">
                    <Panel header="">
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                        </span>
                      </div>
                      <DataTable value={mobdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="CreateDate" sortable header="Date"></Column>
                        <Column field="nameoftheorg" sortable header="Organization name"></Column>
                        <Column field="donorfirstname" sortable header="Donor Name"></Column>
                        <Column field="Amount" sortable header="Amount"></Column>
                      </DataTable>
                    </Panel>
                  </Card>
                </div>
  
              </div>
              <div className="col-1"></div>
            </div>
  
          )}
          </section>
  
  
        </div>
      </div>
      </div>
      </div>
    )
  }
  
 